module.exports = __webpack_public_path__ + "img/xiezhen1.c72c69be.jpg";